import { defineComponent, computed, createVNode } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import { getOperationStyle, getOperationFixedCls } from "./utils.js";
import Checkbox from "../checkbox/index.js";
import Radio from "../radio/index.js";
import IconPlus from "../icon/icon-plus/index.js";
import IconMinus from "../icon/icon-minus/index.js";
var OperationTd = defineComponent({
  name: "OperationTd",
  components: {
    Checkbox,
    Radio,
    IconPlus,
    IconMinus
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    rowKey: {
      type: String,
      default: "key"
    },
    operationColumn: {
      type: Object,
      required: true
    },
    operations: {
      type: Array,
      required: true
    },
    isRadio: {
      type: Boolean
    },
    hasExpand: {
      type: Boolean
    },
    selectedRowKeys: {
      type: Array,
      required: true
    },
    expandedIcon: {
      type: Function
    },
    expandedRowKeys: {
      type: Array,
      required: true
    }
  },
  emits: ["select", "expand"],
  setup(props, {
    emit,
    slots
  }) {
    const prefixCls = getPrefixCls("table");
    const style = computed(() => getOperationStyle(props.operationColumn, props.operations));
    const cls = computed(() => [`${prefixCls}-td`, `${prefixCls}-operation`, {
      [`${prefixCls}-checkbox`]: props.operationColumn.name === "selection" && !props.isRadio,
      [`${prefixCls}-radio`]: props.operationColumn.name === "selection" && props.isRadio,
      [`${prefixCls}-expand`]: props.operationColumn.name === "expand"
    }, ...getOperationFixedCls(prefixCls, props.operationColumn)]);
    const renderSelection = () => {
      var _a;
      const rowKey = props.record[props.rowKey];
      if (props.isRadio) {
        return createVNode(Radio, {
          "modelValue": (_a = props.selectedRowKeys[0]) != null ? _a : "",
          "onChange": (value) => emit("select", [value]),
          "disabled": Boolean(props.record.disabled),
          "value": rowKey
        }, null);
      }
      return createVNode(Checkbox, {
        "modelValue": props.selectedRowKeys,
        "onChange": (values) => emit("select", values),
        "disabled": Boolean(props.record.disabled),
        "value": rowKey
      }, null);
    };
    const renderExpand = () => {
      var _a, _b, _c, _d;
      const rowKey = props.record[props.rowKey];
      const expanded = props.expandedRowKeys.includes(rowKey);
      return createVNode("button", {
        "type": "button",
        "class": `${prefixCls}-expand-btn`,
        "onClick": () => emit("expand", rowKey)
      }, [(_d = (_c = (_a = slots["expand-icon"]) == null ? void 0 : _a.call(slots, {
        expanded,
        record: props.record
      })) != null ? _c : (_b = props.expandedIcon) == null ? void 0 : _b.call(props, expanded, props.record)) != null ? _d : expanded ? createVNode(IconMinus, null, null) : createVNode(IconPlus, null, null)]);
    };
    const renderContent = () => {
      if (props.operationColumn.name === "selection") {
        return renderSelection();
      }
      if (props.operationColumn.name === "expand") {
        if (props.hasExpand) {
          return renderExpand();
        }
        return null;
      }
      if (props.operationColumn.bodyNode) {
        return props.operationColumn.bodyNode(props.record, {
          class: cls.value,
          style: style.value
        });
      }
      return null;
    };
    return () => createVNode("td", {
      "class": cls.value,
      "style": style.value
    }, [createVNode("span", {
      "class": `${prefixCls}-cell`
    }, [renderContent()])]);
  }
});
export { OperationTd as default };
